const initialStarshipsUrl = '/api/starships/'
const initialActorsUrl = '/api/people/'

export { initialStarshipsUrl, initialActorsUrl }